import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import lodashGet from 'lodash/get';
import { useMemo, useCallback, memo } from 'react';
import { FaMinusCircle } from 'react-icons/fa';
import { HighlightEventSource } from '../../../highlight';
const spanStyle = {
    color: 'red',
    fontWeight: 'bold',
};
function RangeAssignmentsColumn({ rowData, assignment, highlight, onUnlinkVisibilityChange, unlinkVisibility, onLink, onUnlink, rowSpanTags, onHover, highlightData, }) {
    const diaIDs = useMemo(() => {
        return lodashGet(rowData, 'diaIDs', 0);
    }, [rowData]);
    const visibilityChangeHandler = useCallback((flag) => {
        onUnlinkVisibilityChange?.(flag);
    }, [onUnlinkVisibilityChange]);
    const spanCss = useMemo(() => {
        const flag = assignment.isActive ||
            assignment.isOver ||
            (highlight.isActive &&
                highlightData.highlight.sourceData?.type !==
                    HighlightEventSource.SIGNAL);
        return flag
            ? {
                color: 'red',
                fontWeight: 'bold',
            }
            : { color: 'black', fontWeight: 'normal' };
    }, [
        assignment.isActive,
        assignment.isOver,
        highlight.isActive,
        highlightData.highlight.sourceData?.type,
    ]);
    return (_jsx("td", { ...rowSpanTags, ...onHover, ...{ onClick: (e) => onLink?.(e, assignment) }, children: rowData.nbAtoms !== undefined && rowData.nbAtoms > 0 ? (rowData.diaIDs && rowData.diaIDs.length > 0 ? (_jsxs("div", { onMouseEnter: () => visibilityChangeHandler(true), onMouseLeave: () => visibilityChangeHandler(false), children: [rowData.nbAtoms, " ", ' ( ', _jsx("span", { style: spanCss, children: diaIDs.length }), ' ) ', _jsx("sup", { children: _jsx("button", { type: "button", style: {
                            visibility: unlinkVisibility ? 'visible' : 'hidden',
                            padding: 0,
                            margin: 0,
                        }, onClick: (e) => onUnlink?.(e, true), children: _jsx(FaMinusCircle, { color: "red" }) }) })] })) : assignment.isActive ? (_jsxs("div", { children: [`${rowData.nbAtoms} (`, _jsx("span", { style: spanStyle, children: "0" }), ')'] })) : (rowData.nbAtoms)) : assignment.isActive ? (_jsxs("div", { children: ['0 (', _jsx("span", { style: spanStyle, children: "0" }), ')'] })) : ('') }));
}
export default memo(RangeAssignmentsColumn);
